import React from 'react'
import { Box, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setUserToken } from '../features/authSlice';
import { setUserInfo } from '../features/userSlice';
import { getToken, storeToken, storeUserType } from '../services/LocalStorageService';
import { useLoginUserMutation } from '../services/userAuthApi';
import { AdminInput, LoadingButton, FieldError } from '../components/ui';

const UserLogin = () => {
  const [server_error, setServerError] = useState({})
  const navigate = useNavigate();
  const [loginUser, { isLoading }] = useLoginUserMutation()
  const dispatch = useDispatch()

  const handleSubmit = async (e) => {

    e.preventDefault();
    const data = new FormData(e.currentTarget);
    const actualData = {
      email: data.get('email'),
      password: data.get('password'),
    }
    const res = await loginUser(actualData)
    if (res.error) {
      setServerError(res.error.data?.errors || { non_field_errors: ["Something went wrong. Please try again."] })
    }
    if (res.data) {
      storeToken(res.data.token)
      storeUserType(res.data.token.type)
      let { access_token } = getToken()
      dispatch(setUserToken({ access_token: access_token }))
      dispatch(setUserInfo({
        id: res.data.token.id,
        first_Name: res.data.token.first_Name,
        last_Name: res.data.token.last_Name,
        email: '',
        type: res.data.token.type,
      }))
      // This panel is for STAFF/ADMIN only; the /admin route guard sends
      // anyone else straight back here.
      navigate('/admin/dashboard')
    }
  }
  let { access_token } = getToken()
  useEffect(() => {
    dispatch(setUserToken({ access_token: access_token }))
  }, [access_token, dispatch])

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f5f6fa', px: 2 }}>
      <Box sx={{ width: '100%', maxWidth: 420 }}>
        <Box textAlign="center" sx={{ mb: 3 }}>
          <Typography sx={{ fontWeight: 900, fontSize: 32, lineHeight: 1 }}>
            <Box component="span" sx={{ color: '#222222' }}>Bake</Box>
            <Box component="span" sx={{ color: '#5b3ff2' }}>Now</Box>
          </Typography>
        </Box>
        <Box sx={{ width: '100%', borderRadius: '14px', border: '1px solid var(--admin-border)', background: 'var(--admin-card-bg)', p: 4 }}>
          <Typography sx={{ fontSize: 20, fontWeight: 800, color: 'var(--admin-text)', textAlign: 'center', mb: 0.5 }}>
            Admin Login
          </Typography>
          <Typography sx={{ fontSize: 13.5, color: 'var(--admin-text-muted)', textAlign: 'center', mb: 3 }}>
            Sign in to manage BakeNow
          </Typography>
          <Box
            component="form"
            noValidate
            id="login-form"
            onSubmit={handleSubmit}
          >
            <AdminInput
              required
              id="email"
              name="email"
              label="Email Address"
              error={server_error.email?.[0]}
            />
            <AdminInput
              required
              id="password"
              name="password"
              label="Password"
              type="password"
              error={server_error.password?.[0]}
            />
            <Box textAlign="center" sx={{ mt: 3 }}>
              <LoadingButton type="submit" loading={isLoading} full>
                Login
              </LoadingButton>
            </Box>
            <FieldError>{server_error.non_field_errors?.[0]}</FieldError>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default UserLogin;
